import env from './env';

const isOnTestServer = () => {
  const host = window.location.origin.split('.');
  const getDomain = host.splice(-2).join('.');
  const testServers = env('POS_TEST_SERVERS')?.split(',');

  return testServers?.includes(getDomain);
};

export default isOnTestServer;
